import styled, { css } from "styled-components";

interface ButtonAnchorProps {
  fill?: boolean;
  outline?: boolean;
  href?: string;
  target?: string;
  download?: string;
}

const ButtonAnchor = styled.a.withConfig({
  shouldForwardProp: (prop) => !["fill", "outline"].includes(prop),
})<ButtonAnchorProps>`
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.32px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.darkColor};
  padding: 10px;
  background-color: ${(props) => (props.fill ? props.theme.colors.darkColor : props.theme.colors.lightColor)};
  color: ${(props) => (props.fill ? props.theme.colors.lightColor : props.theme.colors.darkColor)};

  &:hover {
    background-color: ${(props) => (props.fill ? props.theme.colors.lightColor : props.theme.colors.darkColor)};
    color: ${(props) => (props.fill ? props.theme.colors.darkColor : props.theme.colors.lightColor)};
  }

  ${(props) =>
    props.outline &&
    css`
      background-color: ${(props) => props.theme.colors.lightColor};
      color: ${(props) => props.theme.colors.darkColor};

      &:hover {
        background-color: ${(props) => props.theme.colors.darkColor};
        color: ${(props) => props.theme.colors.lightColor};
      }
    `}

  ${(props) =>
    props.href &&
    css`
      text-decoration: none;
      display: inline-block;
      padding: 10px 20px;
    `}
`;

export default ButtonAnchor;
